import React, { Component } from 'react';

import Select from '@atlaskit/select';

import { ProjectSelectOption } from '@qality/common-model/src/ProjectSelectOption';

type Props = {
  defaultOptions: Array<ProjectSelectOption>;
  onChange: (newValue: ProjectSelectOption) => void;
  loadOptions: (inputValue: string) => Array<ProjectSelectOption>;
  isClearable: boolean;
  value?: ProjectSelectOption;
  isDisabled: boolean;
  placeholder?: string;
  isInvalid: boolean;
  isLoading: boolean;
};

export default class TestCycleProjectSelect extends Component<Props> {
  static defaultProps = {
    isDisabled: false,
  };

  render(): JSX.Element {
    return (
      <Select
        isDisabled={this.props.isDisabled}
        isClearable={this.props.isClearable}
        className='project-select'
        classNamePrefix='solkit'
        options={this.props.defaultOptions}
        placeholder={this.props.placeholder}
        onChange={this.props.onChange}
        value={this.props.value ? this.props.value : undefined}
        validationState={this.props.isInvalid ? 'error' : undefined}
        isLoading={this.props.isLoading}
      />
    );
  }
}
